// extracted by mini-css-extract-plugin
export default {"underlay":"GCCSS","container":"Ujjaw","noPadding":"JiOXf","grey":"HuPMw"};